import { render, staticRenderFns } from "./charmRiskEstimation.vue?vue&type=template&id=4b48b1a5"
import script from "./charmRiskEstimation.vue?vue&type=script&lang=js"
export * from "./charmRiskEstimation.vue?vue&type=script&lang=js"
import style0 from "./charmRiskEstimation.vue?vue&type=style&index=0&id=4b48b1a5&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b48b1a5')) {
      api.createRecord('4b48b1a5', component.options)
    } else {
      api.reload('4b48b1a5', component.options)
    }
    module.hot.accept("./charmRiskEstimation.vue?vue&type=template&id=4b48b1a5", function () {
      api.rerender('4b48b1a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/action/charmRiskEstimation.vue"
export default component.exports